import React from 'react';

import { IButton } from '../types/IButton';

import './button.scss';

const Button: React.FC<IButton> = ({ buttonStyle, handleClick, children }) => {
  return (
    <button className={`pointer ${buttonStyle}`} onClick={handleClick}>
      {children}
    </button>
  );
};

export default Button;
